(function() {
    'use strict';

    angular
        .module('functional7App')
        .controller('ProgramaController', ProgramaController);

    ProgramaController.$inject = ['Programa'];

    function ProgramaController(Programa) {

        var vm = this;

        vm.programas = [];

        loadAll();

        function loadAll() {
            Programa.query(function(result) {
                vm.programas = result;
                vm.searchQuery = null;
            });
        }
    }
})();
